





























































































































































































  import BtnDefault from '@/components/UI/BtnDefault.vue';
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import DialogFooter from '@/components/UI/DialogFooter.vue';
  import {namespace} from 'vuex-class';
  import TableComponent from "@/components/UI/TableComponent.vue";
  import Modal from '@/components/UI/Modal.vue';

  const dialog = namespace('dialog')
  const forms = namespace('forms')
  const products = namespace('products')

  @Component({
    components: {
      BtnDefault,
      DialogFooter,
      TableComponent,
      Modal,
    },
    name: "AddProductForm"
  })
export default class AddProductForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @products.Action('editProduct') protected editProduct:any
  @products.Getter('thematics') protected thematics: any

  tab:string = 'tab-1'
  character:any = {
    title: "",
    value: ""
  }
  currentCharacter:any = {}
  isDeleteCharacter:boolean = false
  link:any = {
    title: "",
    value: ""
  }
  currentPromo:any = {}
  isDeletePromo:boolean = false
  isValid:boolean = false
  product:any = {}
  characters:any = []
  promo:any = []

  @Watch('fullDialogShow')
  resetOptions() {
    if(this.fullDialogShow) {
      this.tab = 'tab-1'
      this.changeIsValid()
      this.checkThematic()
      this.characters = this.options.characters
      this.promo = this.options.promo
    }
  }

  mounted() {
    this.changeIsValid()
    this.checkThematic()
    this.characters = this.options.characters
    this.promo = this.options.promo
  }

  get headersCharacter() {
    return [
      { text: this.$t('products.add.properties.caption'), value: 'title', sortable: false },
      { text: this.$t('products.add.properties.value'), value: 'value', sortable: true },
      { text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deleteCharacterModal' },
    ]
  }
  get headersPromo() {
    return [
      { text: this.$t('products.add.links.description'), value: 'title', sortable: false },
      { text: this.$t('products.add.links.value'), value: 'value', sortable: true },
      { text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deletePromoModal' },
    ]
  }

  get isValidCharacter() {
    return this.character.title.length != 0 && this.character.value.length != 0
  }

  get isValidPromo() {
    return this.link.title.length != 0 && this.link.value.length != 0
  }

   checkThematic() {
    this.thematics.forEach((thematic:any) => {
      if(thematic.title == this.options.thematic) {
        this.options.thematic = thematic.id
      }
    });
   }

  changeIsValid() {
    this.isValid = this.options.title.length != 0
  }

  clickTable(item:any, action:any) {
    this[action as keyof AddProductForm](item)
  }

  addCharacter() {
    this.characters.push(this.character)
    this.character = {
      title: '',
      value: ''
    }
  }

  deleteCharacterModal(item:any) {
    this.currentCharacter = item
    this.isDeleteCharacter = true
  }

  deleteCharacter() {
    this.characters = this.characters.filter((character:any) => character != this.currentCharacter)
    this.isDeleteCharacter = false
  }

  addPromo() {
    this.promo.push(this.link)
    this.link = {
      title: '',
      value: ''
    }
  }

  deletePromoModal(item:any) {
    this.currentPromo = item
    this.isDeletePromo = true
  }

  deletePromo() {
    this.promo = this.promo.filter((link:any) => link != this.currentPromo)
    this.isDeletePromo = false
  }

  save() {
    let params = {
      title: this.options.title,
      vendorCode: this.options.vendorCode,
      description: this.options.description,
      characters: this.characters,
      promo: this.promo,
      thematic: this.options.thematic
    }
    let payload = {
      params: params,
      id: this.options.id
    }
    this.editProduct(payload)
    this.SetFullDialogShow(false)
  }


}
